import { HashLink } from 'react-router-hash-link'
import { ArrowDown, ArrowUp } from 'react-feather'

import { Button } from '@pepper/ui'

import { useSideBarLocation } from './hooks/useSideBarLocation'
import styles from './_.module.css'

type ScrollButtonProps = {
  top?: string
  bottom?: string
  showBottom?: boolean
}

const ScrollButton = ({
  top,
  bottom,
  showBottom,
}: ScrollButtonProps): JSX.Element => {
  const { showTop, setShowTop } = useSideBarLocation()

  return (
    <>
      {showTop && top && (
        <div className={styles.scrollButtonWrapper}>
          <HashLink to={`#${top}`}>
            <Button
              icon={<ArrowUp color="#1600E5" />}
              type="default"
              className={styles.scrollButton}
              onClick={() => setShowTop(false)}
            >
              Back to Top
            </Button>
          </HashLink>
        </div>
      )}

      {bottom && showBottom && !showTop && (
        <div className={styles.scrollButtonWrapper}>
          <HashLink to={`#${bottom}`}>
            <Button
              icon={<ArrowDown color="#1600E5" />}
              type="default"
              className={styles.scrollButton}
            >
              Scroll For More
            </Button>
          </HashLink>
        </div>
      )}
    </>
  )
}

export default ScrollButton
